import styled from '../../../styles/styledComponents/themeComponents';

export const SimpleTableTransferStyle = styled.div`
  .table-transfer-info {
    display: none;
  }
`;
